import { render, staticRenderFns } from "./ToggableTipTap.vue?vue&type=template&id=2283fc46&scoped=true&"
import script from "./ToggableTipTap.vue?vue&type=script&lang=js&"
export * from "./ToggableTipTap.vue?vue&type=script&lang=js&"
import style0 from "./ToggableTipTap.vue?vue&type=style&index=0&id=2283fc46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2283fc46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
